// @ts-ignore
import type * as SchemaTypes from '../index';

import { gql } from 'graphql-tag';
import * as Urql from '@urql/vue';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;

export const QuestionnaireCompleteExistingCustomerDocument = gql`
    mutation questionnaireCompleteExistingCustomer($input: QuestionnaireCompleteInput!) {
  questionnaireCompleteExistingCustomer(input: $input) {
    __typename
  }
}
    `;

export function useQuestionnaireCompleteExistingCustomerMutation() {
  return Urql.useMutation<SchemaTypes.QuestionnaireCompleteExistingCustomerMutation, SchemaTypes.QuestionnaireCompleteExistingCustomerMutationVariables>(QuestionnaireCompleteExistingCustomerDocument);
};